/**
 * Basit açılış kitabı: bilinen ana varyantların konum anahtarları.
 * chess.com tarzında "kitap hamlesi" işareti için kullanılır.
 * Anahtar: tahta dizilimi + oynama sırası + rok hakları (saat/en passant yok).
 */
import { Chess } from "chess.js";

const LINES: string[][] = [
  // 1.e4 e5 açık oyunlar
  ["e4", "e5", "Nf3", "Nc6", "Bb5", "a6"],
  ["e4", "e5", "Nf3", "Nc6", "Bb5", "Nf6"],
  ["e4", "e5", "Nf3", "Nc6", "Bc4", "Bc5"],
  ["e4", "e5", "Nf3", "Nc6", "Bc4", "Nf6"],
  ["e4", "e5", "Nf3", "Nc6", "Bc4", "Nf6", "d3", "Bc5", "O-O", "d6", "c3"],
  ["e4", "e5", "Nf3", "Nc6", "d4", "exd4", "Nxd4"],
  ["e4", "e5", "Nf3", "d6", "d4", "exd4", "Nxd4", "Nf6", "Nc3"],
  // Sicilya
  ["e4", "c5", "Nf3", "d6", "d4", "cxd4", "Nxd4", "Nf6", "Nc3"],
  ["e4", "c5", "Nf3", "d6", "d4", "cxd4", "Nxd4", "Nf6", "Nc3", "a6"],
  ["e4", "c5", "Nf3", "Nc6", "d4", "cxd4", "Nxd4", "Nf6", "Nc3", "e5"],
  ["e4", "c5", "Nf3", "e6", "d4", "cxd4", "Nxd4", "a6"],
  ["e4", "c5", "c3", "Nf6", "e5", "Nd5"],
  // Fransız
  ["e4", "e6", "d4", "d5", "Nc3", "Nf6", "e5", "Nfd7"],
  ["e4", "e6", "d4", "d5", "Nd2", "Nf6", "e5", "Nfd7"],
  // Caro-Kann
  ["e4", "c6", "d4", "d5", "Nc3", "dxe4", "Nxe4", "Bf5"],
  ["e4", "c6", "d4", "d5", "e5", "Bf5"],
  // İskandinav / Pirc / Modern
  ["e4", "d5", "exd5", "Qxd5", "Nc3", "Qa5"],
  ["e4", "d6", "d4", "Nf6", "Nc3", "g6"],
  ["e4", "g6", "d4", "Bg7", "Nc3", "d6"],
  // 1.d4 kapalı oyunlar
  ["d4", "d5", "c4", "e6", "Nc3", "Nf6", "Bg5"],
  ["d4", "d5", "c4", "c6", "Nf3", "Nf6", "Nc3"],
  ["d4", "d5", "Nf3", "Nf6", "Bf4"],
  ["d4", "Nf6", "c4", "g6", "Nc3", "Bg7", "e4", "d6"],
  ["d4", "Nf6", "c4", "e6", "Nf3", "b6"],
  ["d4", "Nf6", "c4", "e6", "Nc3", "Bb4"],
  // İngiliz / Reti
  ["c4", "e5", "Nc3", "Nf6", "Nf3", "Nc6"],
  ["Nf3", "d5", "g3", "Nf6", "Bg2"],
];

function fenKey(fen: string): string {
  const p = fen.split(" ");
  return `${p[0]} ${p[1]} ${p[2]}`;
}

const BOOK_KEYS: Set<string> = (() => {
  const set = new Set<string>();
  for (const line of LINES) {
    const c = new Chess();
    set.add(fenKey(c.fen()));
    for (const san of line) {
      try {
        c.move(san);
        set.add(fenKey(c.fen()));
      } catch {
        break; // o varyantta elle yazım hatası varsa o kadarını al
      }
    }
  }
  return set;
})();

export function isBookPosition(fen: string): boolean {
  return BOOK_KEYS.has(fenKey(fen));
}
